import api, { apiRaw } from "./api";
class UserService {
    static async identificacaoUsuarioLogado() {
        const res = await apiRaw.get("/usuarios/identificacao-usuario-logado");
        return res.data.status === 1 ? res.data.user : undefined;
    }
    static async salvarPerfil(data, secao) {
        const res = await api.post(`/restrito/usuarios/salvar-perfil?secao=${secao}`, data);
        return res.data;
    }
    static async excluirConta(user_id) {
        const res = await api.post(`restrito/usuarios/${user_id}/excluir-conta`);
        return res.data;
    }
    static async meuResumoFinanceiro() {
        const res = await api.get(`restrito/usuarios/meu-resumo-financeiro`);
        return res.data;
    }
}
export default UserService;
